// src/context/TemplateContext.js
import { createContext } from "react";
export const TemplateContext = createContext({
  templateId: null,
  setTemplateId: () => {}
});
